<template>
  <div style="padding: 20px">
    <div style="margin-bottom: 20px">
      <select-area @areaListId="getAreaListId"/>
      <el-input
          v-model="query.studentInfo"
          placeholder="学员姓名"
          style="width: 200px"
      ></el-input>
      <el-select v-model="query.week" placeholder="请选择" style="width: 160px;margin-left: 10px">
        <el-option v-for="item in weekList" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <el-button
          type="primary"
          icon="Search"
          style="margin-left: 10px"
          @click="selectPage"
      >搜索
      </el-button>
      <el-button
          type="primary"
          style="margin-left: 10px"
          @click="exportScheduleInfo"
      >下 载
      </el-button>
      <el-button
          type="primary"
          style="margin-left: 10px"
          @click="importModel=true"
      >导入校区
      </el-button>
    </div>
    <el-table
        :row-style="{ height: 16 + 'px' }"
        :cell-style="{ padding: 16 + 'px' }"
        :data="tableData"
        style="width: 100%">
      <el-table-column prop="areaName" label="校区" width="180" show-overflow-tooltip/>
      <el-table-column  label="学员">
        <template #default="scope">
          {{scope.row.studentName}} - {{scope.row.phone}}
        </template>
      </el-table-column>
      <el-table-column  label="学员">
        <template #default="scope">
          {{scope.row.weekStr}}  {{scope.row.timeStage}}
        </template>
      </el-table-column>
      <el-table-column
          prop="ageStage"
          label="年龄段">
      </el-table-column>
    </el-table>
    <!-- 分页数据-->
    <div class="pagination">
      <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="query.pageIndex"
          :page-size="query.pageSize"
          :total="query.pageTotal"
          @current-change="handlePageChange"
      ></el-pagination>
    </div>
    <el-dialog v-model="importModel" title="导入排课表" width="700" >
      <el-date-picker
          v-model="dateSection"
          format="YYYY-MM-DD"
          value-format="YYYY-MM-DD"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
      </el-date-picker>

      <el-upload v-loading="importLoading"
                 drag style="width: 300px;margin:60px auto"
                 :limit="1"
                 :auto-upload="false"
                 :on-change="fileChange"
                 :file-list="fileList"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
      <el-link @click="template" type="primary">下载模板</el-link>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="importModel = false">取 消</el-button>
          <el-button :disabled="importLoading" type="primary" @click="importScheduleClasses">确 定</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import SelectArea from "../../components/SelectArea";
import { importScheduleClasses,selectScheduleClassesPage,exportScheduleInfo} from "../../api/coursesRecord";

export default {
  name: "CourseScheduling",
  components:{
    SelectArea
  },
  data(){
    return{
      weekList:[{id:1,name:"周一"},{id:2,name:"周二"},{id:3,name:"周三"},{id:4,name:"周四"},{id:5,name:"周五"},{id:6,name:"周六"},{id:6,name:"周日"}],
      dateSection:null,
      importLoading:false,
      importModel:false,
      file:null,
      query:{
        areaList: [],
        pageIndex: 1,
        pageSize: 10,
        studentInfo:"",
        week: null,
        pageTotal:0
      },
      tableData:[]
    }
  },
  methods:{
    exportScheduleInfo(){
      exportScheduleInfo(this.query);
      this.$message.success('下载成功，请注意右上角下载查看文件!')
    },
    handlePageChange(index){
      this.query.pageIndex=index;
      this.selectPage();
    },
    //点选选择某个区域
    getAreaListId(val) {
      this.query.areaList = val;
    },
    template(){
      let url = "https://minio.yanhuotiyu.com/oa.work/File/20250903053339vTFfGllf.xlsx";
      const link = document.createElement('a');
      link.href = url;
      // 设置下载文件名（可选）
      link.download = "文件名称.xlsx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    // 文件状态改变时的钩子
    fileChange(file) {
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (extension !== "xlsx" && extension !== "xls") {
        this.$message.warning("只能上传后缀是.xlsx的文件");
      }
      this.file = file.raw;
    },
    importScheduleClasses(){
      if (this.dateSection==null || this.dateSection.length<1){
        this.$message.warning("请选择排课日期！");
        return;
      }
      if (this.file==null){
        this.$message.warning("请选择排课表！");
        return;
      }
      this.importLoading = true;
      let form = new FormData();
      form.append("file", this.file);
      form.append("startDate", this.dateSection[0]);
      form.append("endDate", this.dateSection[1]);
      importScheduleClasses(form).then(val=>{
        this.importLoading = false;
        if (val.code == 200){
          this.importModel=false;
          this.$message.success("上传成功！");
        }else {
          this.$message.info("上传失败！");
        }
      })
    },
    selectPage(){
      selectScheduleClassesPage(this.query).then(val=>{
        if (val.code == 200){
          this.query.pageTotal = val.data.total;
          this.tableData = val.data.records;
        }
      })
    }
  },
  created() {
    this.selectPage();
  }
}
</script>

<style scoped>

</style>
